import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import Link from 'Component/Link';

import './CustomerService.style';

/** @namespace PeggysagePwa/Component/CustomerService/Component */
export class CustomerServiceComponent extends PureComponent {
    static propTypes = {
        isLoading: PropTypes.bool.isRequired,
        phone: PropTypes.string.isRequired,
        hasContactLink: PropTypes.bool.isRequired,
        title: PropTypes.string.isRequired
    };

    renderTitle() {
        const { title } = this.props;

        if (title === '') {
            return null;
        }

        return (
            <h3 block="CustomerService" elem="Title">
                { title }
            </h3>
        );
    }

    renderPhone() {
        const { isLoading, phone } = this.props;

        if (isLoading || !phone) {
            return null;
        }

        return (
            <a
              block="Button"
              mods={ { CustomerService: true } }
              href={ `tel:${phone.replaceAll(' ', '')}` }
            >
                { phone }
            </a>
        );
    }

    renderContact() {
        const { hasContactLink } = this.props;

        if (!hasContactLink) {
            return null;
        }

        return (
            <Link
              block="Button"
              mods={ { isHollow: true, Contact: true } }
              to="/contact"
            >
                { __('Contact us') }
            </Link>
        );
    }

    render() {
        const { hasContactLink, phone } = this.props;

        if (!phone && !hasContactLink) {
            return null;
        }

        return (
            <div block="CustomerService">
                { this.renderTitle() }
                <div block="CustomerService" elem="Content">
                    { this.renderPhone() }
                    { this.renderContact() }
                </div>
            </div>
        );
    }
}

export default CustomerServiceComponent;
